<template>
    <div>
       
        <div class="container">
    <div class="header">
        <h1>HIROPAY</h1>
        <h2>Politique de Confidentialité</h2>
    </div>

    <!-- Politique de confidentialité -->
    <section id="privacy">
        <h3 class="section-title">Politique de Confidentialité</h3>
        <p>Dernière mise à jour : [01/06/2023]</p>

        <h4>1. Introduction</h4>
        <p>Chez HIROPAY, nous attachons une importance particulière à la confidentialité et à la sécurité de vos données personnelles. Cette politique de confidentialité détaille la manière dont nous recueillons, utilisons, partageons et protégeons vos informations. En utilisant nos services, vous acceptez les pratiques décrites ici.</p>

        <h4>2. Données Collectées</h4>
        <p>HIROPAY collecte différentes catégories de données pour fournir et améliorer ses services. Voici les types de données que nous recueillons :</p>
        
        <p><strong>2.1. Informations d'Inscription</strong><br>
            Lorsque vous créez un compte, nous recueillons des informations essentielles :</p>
        <ul>
            <li>Nom complet</li>
            <li>Adresse e-mail</li>
            <li>Numéro de téléphone</li>
            <li>Informations bancaires et/ou de portefeuille numérique pour traiter les transactions</li>
        </ul>

        <p><strong>2.2. Informations de Transaction</strong><br>
            Pour chaque transaction, nous recueillons des détails spécifiques, incluant :</p>
        <ul>
            <li>Le montant de la transaction</li>
            <li>La devise utilisée</li>
            <li>Les parties impliquées dans l'échange</li>
            <li>La date et l’heure de la transaction</li>
        </ul>

        <p><strong>2.3. Données Techniques</strong><br>
            Ces données nous aident à analyser et optimiser nos services :</p>
        <ul>
            <li>Adresse IP et localisation approximative (si activée)</li>
            <li>Informations sur le type de navigateur et de l'appareil</li>
            <li>Données de connexion (temps passé sur le site, pages visitées, etc.)</li>
        </ul>

        <p><strong>2.4. Cookies et Technologies Similaires</strong><br>
            Nous utilisons des cookies pour personnaliser votre expérience et fournir des publicités adaptées à vos intérêts. Vous pouvez ajuster les paramètres de cookies dans votre navigateur.</p>

        <h4>3. Utilisation des Données</h4>
        <p>Les informations recueillies sont utilisées dans le but de :</p>
        <ul>
            <li>Fournir et gérer les services HIROPAY</li>
            <li>Vérifier l'identité des utilisateurs dans le cadre des lois AML/KYC (Lutte contre le blanchiment et le financement du terrorisme)</li>
            <li>Faciliter les transactions et garantir leur sécurité</li>
            <li>Améliorer nos services grâce à l'analyse des comportements utilisateurs</li>
            <li>Répondre aux demandes de support client et fournir une assistance rapide</li>
            <li>Communiquer avec les utilisateurs pour les mises à jour ou offres spéciales</li>
        </ul>

        <h4>4. Partage des Données</h4>
        <p>HIROPAY peut partager vos informations dans les cas suivants :</p>
        <ul>
            <li><strong>Partenaires de Service :</strong> Avec des prestataires de services nécessaires au bon fonctionnement du site (ex. processeurs de paiement).</li>
            <li><strong>Obligations Légales :</strong> Avec les autorités si la loi l'exige, notamment pour les enquêtes sur des activités suspectes ou frauduleuses.</li>
        </ul>
        <p>HIROPAY s’engage à ne jamais vendre ou louer vos informations personnelles à des fins commerciales sans votre consentement.</p>

        <h4>5. Sécurité des Données</h4>
        <p>Nous avons mis en place des mesures rigoureuses pour garantir la sécurité des informations personnelles :</p>
        <ul>
            <li><strong>Cryptage des données :</strong> Les informations sensibles sont chiffrées pour en empêcher l'accès non autorisé.</li>
            <li><strong>Pare-feu et Systèmes Anti-DDoS :</strong> Des protections supplémentaires pour sécuriser l’infrastructure.</li>
            <li><strong>Authentification à deux facteurs (2FA) :</strong> Une couche de sécurité supplémentaire pour les connexions utilisateurs.</li>
        </ul>
        <p>Bien que nous déployions tous les efforts nécessaires, il est important de noter qu'aucune transmission de données n'est totalement sécurisée. Vous êtes invité à utiliser HIROPAY en toute connaissance des risques potentiels.</p>

        <h4>6. Vos Droits</h4>
        <p>Conformément aux lois applicables, vous disposez de droits concernant vos données personnelles :</p>
        <ul>
            <li><strong>Droit d'Accès :</strong> Demander l’accès à vos données personnelles en notre possession.</li>
            <li><strong>Droit de Rectification :</strong> Corriger ou mettre à jour les informations inexactes.</li>
            <li><strong>Droit de Suppression :</strong> Demander la suppression de vos données, sous réserve de certaines obligations légales.</li>
            <li><strong>Droit d’Opposition :</strong> Vous pouvez vous opposer au traitement de vos données pour des motifs légitimes.</li>
        </ul>
        <p>Pour exercer ces droits, veuillez nous contacter à <a href="mailto:support@hiropay.com">support@hiropay.com</a>. Nous nous engageons à répondre à votre demande dans les meilleurs délais, tout en respectant les exigences légales.</p>

        <h4>7. Conservation des Données</h4>
        <p>HIROPAY conserve vos informations personnelles pour la durée nécessaire à la réalisation des finalités décrites dans cette politique. Les données relatives aux transactions sont conservées pendant une durée minimale de cinq ans, conformément aux réglementations en vigueur.</p>

        <h4>8. Protection des Mineurs</h4>
        <p>HIROPAY ne propose pas ses services aux personnes de moins de 18 ans et ne collecte pas sciemment de données personnelles de mineurs. Si un compte est identifié comme appartenant à une personne mineure, nous prendrons les mesures nécessaires pour le désactiver et supprimer les informations associées.</p>

        <h4>9. Modifications de la Politique de Confidentialité</h4>
        <p>HIROPAY se réserve le droit de mettre à jour cette politique de confidentialité pour refléter les évolutions de nos pratiques ou des lois applicables. Toute modification substantielle sera communiquée via notre site ou par e-mail. En continuant à utiliser nos services après une mise à jour, vous acceptez les conditions révisées de la politique de confidentialité.</p>

        <h4>10. Contact</h4>
        <p>Pour toute question, demande d’information ou clarification au sujet de cette politique de confidentialité, veuillez nous contacter à l’adresse suivante : <a href="mailto:support@hiropay.com">support@hiropay.com</a>. Nous sommes disponibles pour répondre à toutes vos questions concernant la protection de vos données et l'utilisation de nos services.</p>
    </section>
</div>

    <subFooter />
    </div>
</template>

<script>
const subFooter = () => import("../components/subFooter");
    export default {
        components: {
    subFooter
  },
        
    }
</script>

<style>
      /* Reset */
      * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
      }

      /* Base Colors */
      :root {
          --primary-color: #003449;
          --secondary-color: #005f99;
          --background-color: #f4f8fb;
          --text-color: #333;
          --accent-color: #ffaa00;
      }

      /* Layout */
   

      .container {
          max-width: 900px;
          margin: 0 auto;
         
      }

      div.header {
          background-color: #003449;
          color: #fff;
          padding: 20px 0;
          text-align: center;
          border-bottom: 4px solid var(--accent-color);
      }

      h1 {
          font-size: 2.5em;
          margin-bottom: 0.5em;
      }

      h2 {
          font-size: 1.2em;
          font-weight: 300;
      }


      h3 {
          font-size: 1.8em;
          color: var(--primary-color);
          margin-bottom: 0.5em;
      }

      h4 {
          font-size: 1.4em;
          color: var(--secondary-color);
          margin-top: 1em;
      }

      p {
          margin-bottom: 1em;
          text-align: justify;
      }

      footer {
          background-color: var(--secondary-color);
          color: #fff;
          text-align: center;
          padding: 10px 0;
          margin-top: 20px;
      }

      /* Enhancements */
      #terms, #privacy {
          background-color: #fff;
          padding: 20px;
          margin-bottom: 20px;
          border-radius: 5px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      }

      footer p {
          font-size: 0.9em;
      }

      /* Appliquer une marge gauche aux éléments de liste */
      ul, ol {
          margin-left: 50px;
      }

      ul li, ol li {
          margin-bottom: 0.5em;
      }
  </style>